import React from 'react'
import WriteOffActItemButton from '../form/WriteOffActItemButton'

const WriteOffActItemsActions = ({ writeOffActId }) => {
  return (
    <div className='supplyOrderView__actions'>
        <WriteOffActItemButton 
            writeOffActId={writeOffActId}
        />
    </div>
  )
}

export default WriteOffActItemsActions